import { render, staticRenderFns } from "./PreviewFrameDrop.vue?vue&type=template&id=052d00be&lang=pug"
import script from "./PreviewFrameDrop.vue?vue&type=script&lang=js"
export * from "./PreviewFrameDrop.vue?vue&type=script&lang=js"
import style0 from "./PreviewFrameDrop.vue?vue&type=style&index=0&id=052d00be&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports